import SimpleCoverageCarousel from './SimpleCoverageCarousel';
import CustomClientError from '../../../errorhandling/CustomClientError';
import React from 'react';
import SelectComponent from '../../common/auto-suggestion-select/Select';
import { useCoverage } from './hooks';
import './coverage.scss';
import { useTranslation } from 'react-i18next';
import { Card, CardGroup, Row, Col, Container } from 'react-bootstrap';
import {
  ClientErrorSVG,
  ClientNoDataFoundSVG,
} from '../../../img/ClientErrorSVG';

const SimpleCoverage = (props) => {
  const {
    memberAccumulatedData,
    defaultNetworkForAll,
    activeMember,
    activeMemberIndex,
    skeletonLoader,
    isAPIFailed,
    isNotFound,
  } = useCoverage();

  const { t } = useTranslation();
  return isAPIFailed ? (
    <div className="px-0">
      {isNotFound ? (
        <div className="mtop30 No-data-container">
          <Row>
            <Col className="my-auto p-3 d-flex justify-content-center">
              <ClientNoDataFoundSVG
                className="client-error-mark"
                parentClassName="clienterrorsvg"
                circleClass="error-circle"
              />
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center">
              <h1 role="alert">No Data Found</h1>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center">
              <p role="alert">Try again later.</p>
            </Col>
          </Row>
        </div>
      ) : (
        <div className="mtop30 coverage-error-container">
          <Row>
            <Col className="my-auto mh-80 p-3 d-flex justify-content-center">
              <ClientErrorSVG
                className="client-error-mark"
                parentClassName="clienterrorsvg"
                circleClass="error-circle"
                svgHeight={true}
                height="100"
              />
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center">
              <h1 className="p-0 m-0" role="alert">
                Something went wrong!
              </h1>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center">
              <p className="fail">Failed to retrieve data.</p>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center">
              <p role="alert">Try again later.</p>
            </Col>
          </Row>
        </div>
      )}
    </div>
  ) : (
    <>
      <div className="simple-coverage-container">
        <div className="wrapper">
          <SimpleCoverageCarousel
            activeMember={activeMember}
            memberAccumulatedData={memberAccumulatedData}
            defaultNetworkForAll={defaultNetworkForAll}
            skeletonLoader={skeletonLoader}
            activeMemberIndex={activeMemberIndex}
          />
        </div>
      </div>
    </>
  );
};
export default SimpleCoverage;
